import React from "react";

const Account = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path fill="#fff" fillOpacity=".87" d="M8 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm5 14h-1v-2.5A2.5 2.5 0 009.5 10h-3A2.5 2.5 0 004 12.5V15H3v-2.5A3.5 3.5 0 016.5 9h3a3.5 3.5 0 013.5 3.5V15z" />
  </svg>
);

export default Account;
